const errorsDictionary = {
  document: {
    message: 'Necessário um documento válido',
    required: 'Campo documento é obrigatório.',
    validate: 'O documento precisar ser válido'
  },
  image: {
    message: 'Necessário uma imagem válida',
    required: 'Tipo da imagem .jpg, .jpeg e .png com no máximo 10mb',
    pattern: 'É permitido apenas PNG e JPEG'
  }
}

export default (key, defaultMessage, errors) => {
  if (!errors) {
    throw new Error('Errors object is required')
  }

  if (!errors[key]) {
    return defaultMessage
  }

  switch (errors[key].type) {
    case 'pattern':
      return errorsDictionary[key].pattern

    case 'required':
      return errorsDictionary[key].required

    default:
      return errorsDictionary[key].message
  }
}
